import React, { useState } from 'react';
import clsx from 'classnames';
import './index.css';

const Case = () => {
  const [activeItem, setActiveItem] = useState('1');
  const caseList = [
    {
      id: '1',
      title: '标准验证试验',
      imgUrl: '/images/caseType1.jpg',
    },
    {
      id: '2',
      title: '特种车辆试验',
      imgUrl: '/images/caseType2.jpg',
    },
    {
      id: '3',
      title: '批量抽检',
      imgUrl: '/images/caseType3.png',
    },
    {
      id: '4',
      title: '标准编制',
      imgUrl: '/images/caseType4.jpg',
    },
  ];

  const onMouseEnter = (item) => {
    setActiveItem(item.id);
  };

  return (
    <div className={clsx('business-case')}>
      <div className={clsx('business-case-title')}>服务案例</div>
      <div className={clsx('business-case-desc')}>
        多维项目经验，保证服务质量
      </div>
      <div className={clsx('business-case-content')}>
        {caseList.map((item, index) => (
          <div
            className={clsx('business-case-item', {
              caseItemActive: activeItem === item.id,
            })}
            key={item.id}
            style={{
              backgroundImage: `url(${item.imgUrl})`,
            }}
            onMouseEnter={() => onMouseEnter(item)}
            onMouseLeave={() => onMouseEnter(item)}
          >
            <div className={clsx('business-case-item-title')}>{item.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Case;
